import { createContext } from 'react';

export const StaticExportContext = createContext(false);
